import { styled } from "@mui/material/styles";

export const SmoothCollapseContainer = styled("div", {
  label: "smooth-collapse",
})<{
  open: boolean;
}>`
  overflow: hidden;
  transition:
    height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s;
  height: var(--input-height, 0px);
  opacity: ${({ open }) => (open ? 1 : 0)};
`;
